import { useState, type ReactNode } from 'react'
import { FilterBar, PageHeader, LaporanTampil, FILTER_KOSONG, type NilaiFilter } from '@/components'
import { useApi } from '@/lib/useApi'
import { useOpsiUnit } from '@/lib/opsi'
import { awalTahunIni, tanggalHariIni } from '@/lib/format'

/**
 * Kerangka halaman laporan keuangan: filter periode/unit + ekspor + render.
 * Dipakai oleh Neraca, Laporan Aktivitas, Arus Kas, Neraca Saldo, Konsolidasi.
 */
export function HalamanLaporan({
  judul,
  deskripsi,
  path,
  namaEkspor,
  eksporPath,
  tampilkanUnit = true,
  ringkasFilter = true,
  ekstraKonten,
  queryTambahan,
  aktif = true,
}: {
  judul: string
  deskripsi: string
  path: string
  namaEkspor: string
  eksporPath?: string
  tampilkanUnit?: boolean
  ringkasFilter?: boolean
  ekstraKonten?: (data: unknown) => ReactNode
  queryTambahan?: Record<string, string | undefined>
  aktif?: boolean
}) {
  const opsiUnit = useOpsiUnit()
  const [filter, setFilter] = useState<NilaiFilter>({
    ...FILTER_KOSONG,
    dari: awalTahunIni(),
    sampai: tanggalHariIni(),
  })

  const hasil = useApi<unknown>(path, {
    dari: filter.dari || undefined,
    sampai: filter.sampai || undefined,
    unitId: filter.unitId || undefined,
    ...queryTambahan,
  })

  return (
    <div>
      <PageHeader
        judul={judul}
        deskripsi={deskripsi}
        ekspor={{
          path: eksporPath ?? path,
          namaDasar: namaEkspor,
          query: {
            dari: filter.dari || undefined,
            sampai: filter.sampai || undefined,
            unitId: filter.unitId || undefined,
            ...queryTambahan,
          },
        }}
      />

      <FilterBar
        nilai={filter}
        onUbah={setFilter}
        unit={opsiUnit}
        ringkas={ringkasFilter}
        tampilkan={{
          unitId: tampilkanUnit,
          dari: true,
          sampai: true,
          fundId: false,
          program: false,
          kategori: false,
        }}
      />

      {ekstraKonten ? ekstraKonten(hasil.data) : null}

      <LaporanTampil
        data={hasil.data}
        memuat={hasil.memuat}
        galat={hasil.galat}
        kodeGalat={hasil.kodeGalat}
        onCoba={hasil.muat}
        kosong={
          <p className="py-6 text-center text-sm text-netral-500">
            {aktif ? 'Tidak ada data pada periode ini.' : 'Endpoint laporan ini belum tersedia.'}
          </p>
        }
      />
    </div>
  )
}
